"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcPositionValue = void 0;
const Tooltip_1 = require("../atoms/Tooltip");
const rectCenter_1 = require("./rectCenter");
function calcPositionValue(position, targetRect, selfOuterSize) {
    let positionValue = position;
    const targetCenter = (0, rectCenter_1.getRectCenter)(targetRect);
    if (positionValue === Tooltip_1.TooltipPosition.Auto) {
        if (targetCenter.left - selfOuterSize.width >= 0) {
            positionValue = Tooltip_1.TooltipPosition.Left;
        }
        else if (targetCenter.left + selfOuterSize.width <= window.innerWidth) {
            positionValue = Tooltip_1.TooltipPosition.Right;
        }
        else if (targetCenter.top - selfOuterSize.height >= 0) {
            positionValue = Tooltip_1.TooltipPosition.Top;
        }
        else if (targetCenter.top + selfOuterSize.height <= window.innerHeight) {
            positionValue = Tooltip_1.TooltipPosition.Bottom;
        }
    }
    return positionValue;
}
exports.calcPositionValue = calcPositionValue;
